var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVideoPlayButton = function SvgVideoPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 69,
    viewBox: "0 0 70 69"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M34.85 68.789C15.927 68.789.586 53.469.586 34.572S15.926.356 34.851.356s34.266 15.319 34.266 34.216c0 18.898-15.342 34.217-34.266 34.217M27.873 46.03l20.01-9.991-20.01-9.99z"
  })));
};
export default SvgVideoPlayButton;